<template>
  <div>
    <div id="activities">
      <div id="tab-bar">
        <router-link id="training-tab" to="/activities/training" class="tab">
          <div class="tab-icon" />
          <div class="tab-title">{{ $t('home.training')}}</div>
        </router-link>

        <router-link id="school-tab" to="/activities/school" class="tab">
          <div class="tab-icon" />
          <div class="tab-title">{{ $t('home.school')}}</div>
        </router-link>

        <router-link id="monday-tab" to="/activities/monday" class="tab">
          <div class="tab-icon" />
          <div class="tab-title">{{ $t('home.happyMonday')}}</div>
        </router-link>

        <router-link id="drama-tab" to="/activities/drama" class="tab">
          <div class="tab-icon" />
          <div class="tab-title">{{ $t('home.drama')}}</div>
        </router-link>

        <router-link id="phone-tab" to="/activities/phone" class="tab">
          <div class="tab-icon" />
          <div class="tab-title">{{ $t('home.phone')}}</div>
        </router-link>
        
        <router-link id="train-tab" to="/activities/train" class="tab">
          <div class="tab-icon" />
          <div class="tab-title">{{ $t('home.train')}}</div>
        </router-link>
      </div>

      <div id="activity-list">
        <router-link 
          v-for="activity in activities" 
          class="activity" 
          :to="`/activities/${activity.category}/${activity._id}`"
          :key="activity.id">
            <div class="activity-pic" 
              v-bind:style="activity.coverImage ? { backgroundImage: `url('${activity.coverImage.url}')`} : {}">
              <div class="overlay" />
              <div class="overlay-text">{{ $t('activities.detail')}}</div>
            </div>
            <div class="title-wrapper">
              <div class="name">{{ activity.title }}</div>
              <div class="sub-title">{{ activity.subtitle }}</div>
            </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { getActivitiesByCategory } from '../models/Activity';

export default {
  name: 'Activities',
  beforeRouteUpdate(to, from, next) {
    this.getActivities(to.params.type);
    next();
  },
  mounted() {
    this.getActivities(this.$route.params.type);
  },
  data() {
    return {
      activities: [],
    };
  },
  methods: {
    getActivities(category) {
      getActivitiesByCategory(category).then((records) => {
        this.activities = [...records];
      });
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "../styles/variables.sass"

  #activities
    padding: 42px 85px
    @media #{$mobile}
      padding: 30px 20px

    #mobile-title
      font-size: 24px
      color: $fountain-blue
      text-align: center
      margin-bottom: 35px

    #tab-bar
      display: flex
      justify-content: center
      margin: 0 auto

      @media #{"screen and (max-width: 1080px) and (min-width: 771px)"}
        max-width: 450px
        flex-wrap: wrap
        .tab:first-child
          margin-bottom: 30px

      @media #{$mobile}
        padding-bottom: 100px
        position: relative

      .tab
        color: $fountain-blue

        @media #{$desktop}
          margin: 0 20px
          filter: grayscale(100%)
          -webkit-filter: grayscale(100%)

        @media #{$mobile}
          margin: 0 4px

          &.router-link-active
            position: absolute
            bottom: 0
            transform: translateX(-50%)
            left: 50%
            .tab-title
              display: block
              margin-top: 0px

            .tab-icon
              width: 65px !important
              height: 65px !important
              background-size: contain !important

        &.router-link-active
          -webkit-filter: none
          filter: none

        &:not(.router-link-active)
          .tab-title
            color: $jaffa !important

        .tab-title
          font-size: 16px
          text-align: center
          margin-top: 4px

          @media #{$mobile}
            display: none

        .tab-icon
          width: 100px
          height: 66px
          margin: 0 auto
          background-repeat: no-repeat
          background-position: center
          @media #{$mobile}
            width: 53px
            height: 35px

      #training-tab
        .tab-icon
          background-image: url('../../static/training-icon.png')
          background-size: 80px 55px
          @media #{$mobile}
            background-size: 40px 28px

        .tab-title
          color: $leather

      #school-tab
        .tab-icon
          background-image: url('../../static/school-icon.png')
          background-size: 100px 47px
          @media #{$mobile}
            background-size: 50px 23px
        .tab-title
          color: $jaffa

      #monday-tab
        @media #{$desktop}
          margin-right: 2px
        .tab-icon
          background-image: url('../../static/monday-icon.png')
          background-size: 65px 62px
          @media #{$mobile}
            background-size: 37px 31px
        .tab-title
          color: $fountain-blue

      #drama-tab
        .tab-icon
          background-image: url('../../static/drama-icon.png')
          background-size: 80px 66px
          @media #{$mobile}
            background-size: 40px 33px
        .tab-title
          color: $yellow-orange

      #phone-tab
        @media #{$desktop}
          margin-left: 14px;
        .tab-icon
          background-image: url('../../static/line-icon.png')
          background-size: 69px 56px
          @media #{$mobile}
            background-size: 34px 28px
        .tab-title
          color: $froly-2

      #train-tab
        @media #{$desktop}
          margin-left: 7px;
        .tab-icon
          background-image: url('../../static/train-icon.png')
          background-size: 80px 54px
          @media #{$mobile}
            background-size: 40px 27px
        .tab-title
          color: $leather

    #activity-list
      display: flex
      flex-wrap: wrap
      max-width: 875px
      margin: 0 auto
      margin-top: 45px

      @media #{"screen and (max-width: 1080px) and (min-width: 771px)"}
        max-width: 585px

      @media #{$mobile}
        justify-content: center
        margin-top: 30px

      .activity
        margin: 0 10px
        margin-bottom: 40px

        .overlay-text
          display: none

        @media (hover: hover)
          &:hover
            .overlay
              position: absolute
              top: 0
              left: 0
              right: 0
              bottom: 0
              opacity: 0.6

            .overlay-text
              position: absolute
              display: block
              top: 0
              left: 0
              right: 0
              bottom: 0
              text-align: center
              color: $white
              font-size: 24px
              line-height: 205px


        .activity-pic
          width: 271px
          height: 205px
          border: 1px solid $silver
          background-image: url('../../static/placeholder-image.png')
          background-size: cover
          background-position: center
          position: relative

        .title-wrapper
          font-size: 14px
          color: $white
          padding: 10px 6px

        &:nth-child(6n+1)
          .title-wrapper
            background-color: $jaffa

          .overlay
            background-color: $jaffa

        &:nth-child(6n+2)
          .title-wrapper
            background-color: $olivine

          .overlay
            background-color: $olivine

        &:nth-child(6n+3)
          .title-wrapper
            background-color: $fountain-blue

          .overlay
            background-color: $fountain-blue

        &:nth-child(6n+4)
          .title-wrapper
            background-color: $yellow-orange

          .overlay
            background-color: $yellow-orange

        &:nth-child(6n+5)
          .title-wrapper
            background-color: $gulf-stream

          .overlay
            background-color: $gulf-stream

        &:nth-child(6n+0)
          .title-wrapper
            background-color: $froly

          .overlay
            background-color: $froly

</style>



// WEBPACK FOOTER //
// src/components/Activities.vue